export default {
  title: 'Contratto',
  description: 'Ti verrà addebitato un importo di {{amount}} al mese se non annulli il periodo di prova.',
  bill_at_launch_date: 'Prima fattura alla data di lancio',
  bill_date: 'Data fattura: {{date}}',
  bill_date_after_launch: 'Prima data fattura: {{days}} giorni dopo il lancio',
  sign_agreement: 'Firma il contratto di abbonamento e di partecipazione al ristorante',
  restaurant: 'Ristorante',
  agreement:
    'Accetto i <a href="{{terms_url}}" target="_blank" rel="noreferrer noopener">termini della piattaforma</a>. Posso annullare l\'abbonamento in qualsiasi momento notificando la cancellazione a {{provider}}. L\'abbonamento verrà annullato e il mandato di pagamento revocato non appena il Ristorante contatterà {{provider}} via e-mail o WhatsApp. Nessun ulteriore addebito verrà effettuato al ristorante in seguito. Accetto che il mio consenso elettronico equivalga alla firma del presente documento e comprendo che la mia firma elettronica è vincolante.',
};
